export default __webpack_public_path__ + "static/media/talent-main-section-article2-mobile-Dev-IT.8dfa53c2.png";